import FollowerSuggested from './FollowerSuggested';

const RightBar: React.FC<any> = () => {
  return (
    <div className="w-[calc(100%/4)] lg:hidden">
      <FollowerSuggested />
    </div>
  );
};

export default RightBar;
